import { render, staticRenderFns } from "./RejectedMentorshipRequests.vue?vue&type=template&id=277e4848&scoped=true&"
import script from "./RejectedMentorshipRequests.vue?vue&type=script&lang=js&"
export * from "./RejectedMentorshipRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e4848",
  null
  
)

export default component.exports